export default __webpack_public_path__ + "static/media/Group 845.d5951cc5.svg";